import TagHandler from './TagHandler'

export default TagHandler


// WEBPACK FOOTER //
// ./src/components/tag/index.jsx